export default {"src":"/_next/static/media/0xaaa760c2027817169d7c8db0dc61a2fb4c19ac23.03b0f307.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};